import React from 'react';

import {
  HeaderWrapper,
  HeaderTitle,
  HeaderDescription,
  LineBreak,
} from './styles';

const PolicyHeader = () => {
  return (
    <HeaderWrapper>
        <HeaderTitle>
          Privacy Policy
        </HeaderTitle>
        <HeaderDescription>
          Last Updated: November 26th, 2024
        </HeaderDescription>
        <LineBreak />
    </HeaderWrapper>
  );
};

export default PolicyHeader;
